import React, { FC, ReactNode } from "react";
import { View, Text, ITouchEvent } from "@tarojs/components";
import classNames from "classnames";
import { XHComponentCommonProps } from "../../types";

import "./index.scss";

export type XHListProps = {
  title?: string;
  description?: string | ReactNode;
  icon?: ReactNode;
  extra?: string | ReactNode;
  extraIcon?: ReactNode;
  border?: boolean;
  arrow?: boolean;
  outline?: boolean;
  condensed?: boolean;
  onClick?: (e: ITouchEvent) => void;
  descriptionColor?: string;
  extraColor?: string;
  ellipsis?: boolean;
  padding?: boolean;
  dataTrackId?: string;
} & XHComponentCommonProps;

const XHList: FC<XHListProps> = props => {
  const {
    title = "",
    description = "",
    icon,
    extra = "",
    extraIcon = "",
    arrow,
    border = true,
    onClick,
    className,
    outline = true,
    condensed = false,
    descriptionColor = "",
    extraColor = "",
    ellipsis = true,
    padding = false,
    dataTrackId = "XHList",
  } = props;

  const listcls = classNames(
    "xh-list",
    { border },
    { outline },
    { condensed },
    { padding },
    className
  );

  const mainCls = classNames("xh-list-main", {
    ellipsis,
  });

  const handleClick = (e: ITouchEvent) => {
    onClick && onClick(e);
  };

  return (
    <View
      className={listcls}
      // @ts-ignore
      dataTrackId={dataTrackId}
      onClick={handleClick}
    >
      {icon && <View className="xh-list-icon">{icon}</View>}
      <View className={mainCls}>
        {title && <Text className="xh-list-main-title">{title}</Text>}
        <Text
          className="xh-list-main-description"
          style={{ color: descriptionColor }}
        >
          {description}
        </Text>
      </View>
      <View className="xh-list-extra">
        <View className="xh-list-extra-info" style={{ color: extraColor }}>
          {extra}
        </View>
        <View className="xh-list-extra-icon">
          {extraIcon
            ? extraIcon
            : arrow && <View className="xh-list-extra-icon-arrow" />}
        </View>
      </View>
    </View>
  );
};
export default XHList;
